const CommonColors = {
    PRIMARY: "#498939",
    SECONDARY:"#FDE44D",
    GRAY: 'gray'
}

export default CommonColors